export default {
  title: 'Solicitudes de eliminación de datos',
  fields: {
    created_at: 'Solicitado el',
    restaurant: 'Restaurante',
    customer: 'Cliente',
    note: 'Nota',
    status: 'Estado',
    completed_by: 'Completado por',
    actions: 'Acciones',
  },
  statuses: {
    pending: 'Pendiente',
    completed: 'Completado',
  },
  buttons: {
    approve: 'Aprobar',
  },
  modals: {
    approve: {
      title: '¿Aprobar eliminación de datos de {{name}}?',
      description:
        'Esto elimina permanentemente los datos personales del cliente y no se puede deshacer. La solicitud se marcará como completada.',
    },
  },
  toasts: {
    failed_to_load_data: 'Error al cargar datos',
    failed_to_approve: 'Error al aprobar la solicitud',
    approved: 'Solicitud aprobada y datos eliminados',
  },
};
